import { useStore } from '@nanostores/react';
import { PricingCardActionButton } from './Action';
import { PricingCardBase } from './PricingCardBase';
import { PricingSelector } from './PricingSelector';
import { TEAM_PLAN_PERKS } from '~/lib/stores/pricing/config';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { teamPricingPlansStore } from '~/lib/stores/pricing/teamPlans';
import { userStore } from '~/lib/stores/user';

interface Props {
  tokenStatsMessage: string | null;
}

export const TeamPlansCard = ({ tokenStatsMessage }: Props) => {
  const loggedIn = useStore(userStore.loggedIn);
  const selectedInterval = useStore(pricingStore.selectedInterval);

  const actions = useStore(teamPricingPlansStore.actions);
  const messages = useStore(teamPricingPlansStore.messages);
  const dropdownOptions = useStore(teamPricingPlansStore.dropdownOptions);
  const selectedPricing = useStore(teamPricingPlansStore.selectedPricing);
  const activePricing = useStore(teamPricingPlansStore.activePricing);

  const pricingBeingRequested = useStore(pricingStore.pricingBeingRequested);
  const isLoading = useStore(pricingStore.isLoading);

  const shouldDisplayTokenStatsMessage = selectedPricing?.tier === activePricing?.tier;

  return (
    <PricingCardBase
      title="Teams"
      price={selectedInterval === 'yearly' ? selectedPricing?.rateMonthly.year : selectedPricing?.rateMonthly.month}
      billedLabel={`billed ${selectedInterval}`}
      priceLabel="per month and member"
      selector={
        loggedIn && (
          <PricingSelector
            options={dropdownOptions}
            label="Monthly tokens per member"
            selectedPricing={selectedPricing}
            onSelectPricing={(pricing) => {
              teamPricingPlansStore.selectPricing(pricing);
            }}
          />
        )
      }
      perks={{
        label: 'You get everything in Pro, plus:',
        items: TEAM_PLAN_PERKS,
      }}
      messages={
        tokenStatsMessage && shouldDisplayTokenStatsMessage
          ? [
              {
                text: tokenStatsMessage,
                placement: 'under-selector',
              },
              ...messages,
            ]
          : messages
      }
    >
      {actions.map((action) => (
        <PricingCardActionButton
          key={action.id}
          action={action}
          loading={pricingBeingRequested?.type === 'teams' && pricingBeingRequested.id === action.id}
          disabled={isLoading}
        />
      ))}
    </PricingCardBase>
  );
};
